export const INDUSTRIES = [
  'SaaS',
  'FinTech',
  'Healthcare',
  'E-commerce',
  'Agency',
  'Real Estate',
  'Consulting',
  'Manufacturing',
  'Legal',
  'Education',
  'Media & Entertainment',
  'Logistics',
  'Hospitality',
  'Non-profit',
  'Other',
] as const

export type Industry = (typeof INDUSTRIES)[number]
